import { render, staticRenderFns } from "./GoliveLandingPage.vue?vue&type=template&id=296be014&scoped=true"
import script from "./GoliveLandingPage.vue?vue&type=script&lang=js"
export * from "./GoliveLandingPage.vue?vue&type=script&lang=js"
import style0 from "./GoliveLandingPage.vue?vue&type=style&index=0&id=296be014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296be014",
  null
  
)

export default component.exports